import { useCallback } from 'react';
import { cn } from '../../../../utils';
import { useMenuToggle } from '../../menu.context';
import styles from './hamburger.module.css';
type HamburgerProps = {
  ariaLabel?: string;
  label?: React.ReactNode;
};

export function Hamburger({ ariaLabel, label }: HamburgerProps) {
  const { state, toggle, hamburgerRef } = useMenuToggle();
  const toggleMenu = useCallback(() => toggle(), [toggle]);

  return (
    <button
      role="checkbox"
      type="button"
      id="hamburger"
      aria-describedby="hamburger-label"
      className={cn(styles.wrapper)}
      onClick={toggleMenu}
      ref={hamburgerRef}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={cn(styles.hamburger, state && styles.close)}
        aria-hidden
      >
        <defs>
          <path
            id="bar"
            d="M 23 0 C 23.552 0 24 0.448 24 1 C 24 1.552 23.552 2 23 2 L 1 2 C 0.448 2 0 1.552 0 1 C 0 0.448 0.448 0 1 0 L 23 0 Z"
          ></path>
        </defs>
        <use href="#bar" className={styles.top} x="0" y="6" />
        <use href="#bar" className={styles.middle} x="0" y="12" />
        <use href="#bar" className={styles.bottom} x="0" y="18" />
      </svg>
      <label aria-label={ariaLabel} id="hamburger-label">
        {label}
      </label>
    </button>
  );
}
